import { Component, OnInit, ViewChild } from '@angular/core';
import { TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';

@Component({
    selector: 'app-ipoc-pesquisa',
    templateUrl: './ipoc-pesquisa.component.html',
    standalone: false
})
export class IpocPesquisaComponent {

  textoBotaoCadastro = 'Nova ocorrência'
  textoBotaoEnvio = 'Enviar lote de ocorrências';
  tooltipBotaoEnvio = 'Selecione esta opção para enviar um arquivo para operação com IPOC';
  tiposConteudo: TipoConteudo[] = [TipoConteudo.ATUALIZACAO_SCR];
}
